<template>

  <el-dialog :visible.sync="visible" width="95%" append-to-body :close-on-click-modal="false" @closed="onClosed">

    <template slot="title">

      <div class="doc-dialog-header">

        <span class="doc-dialog-title">{{ dialogTitle }}</span>

        <div v-if="showViewToolbar" class="doc-dialog-actions">

          <el-button-group>

            <el-button v-if="(isAuth('production:productionSubcontract:update') || isAuth('production:productionSubcontract:save')) && form.approveStatus === '0' && !form.purchaseOrderId" type="primary" size="small" @click="readonly = false">修改</el-button>

            <el-button v-if="isAuth('production:productionSubcontract:approveSend') && form.approveStatus === '0'" type="primary" size="small" @click="approve('approveSend', '审核后将扣减发出库存，是否继续？', '1')">审核发出</el-button>

            <el-button v-if="isAuth('production:productionSubcontract:approveSend') && form.approveStatus === '1'" size="small" @click="approve('unapproveSend', '确定弃审发出？库存将加回。', '0')">弃审发出</el-button>

            <el-button v-if="isAuth('production:productionSubcontract:approveReceive') && form.approveStatus === '1'" type="primary" size="small" @click="approve('approveReceive', '审核后将增加收回库存，是否继续？', '2')">审核收回</el-button>

            <el-button v-if="isAuth('production:productionSubcontract:approveReceive') && form.approveStatus === '2'" size="small" @click="approve('unapproveReceive', '确定弃审收回？', '1')">弃审收回</el-button>

            <el-button v-if="isAuth('production:productionSubcontract:delete') && form.approveStatus === '0' && !form.purchaseOrderId" type="primary" size="small" @click="remove">删除</el-button>

          </el-button-group>

        </div>

      </div>

    </template>

    <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px">

      <el-row :gutter="10">

        <el-col :span="8"><el-form-item label="委外单号"><el-input v-model="form.code" :disabled="formDisabled || !!form.id || codeReadonly" :placeholder="codeReadonly ? '保存时按单据规则生成' : '请输入委外单号'" /></el-form-item></el-col>

        <el-col :span="8"><el-form-item label="日期" prop="bizDate"><el-date-picker v-model="form.bizDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" :disabled="formDisabled" style="width:100%" /></el-form-item></el-col>

        <el-col :span="8">

          <el-form-item label="生产工单" prop="productionOrderId">

            <el-input :value="form.productionOrderCode" readonly placeholder="选择工单">

              <el-button v-if="!formDisabled" slot="append" @click="pickOrder">选择</el-button>

            </el-input>

          </el-form-item>

        </el-col>

        <el-col :span="8">

          <el-form-item label="委外工序" prop="orderRoutingId">

            <el-select v-model="form.orderRoutingId" filterable :disabled="formDisabled || !form.productionOrderId" style="width:100%" placeholder="选择外协工序">

              <el-option v-for="item in routings" :key="item.orderRoutingId" :label="item.processName" :value="item.orderRoutingId" />

            </el-select>

          </el-form-item>

        </el-col>

        <el-col :span="8">

          <el-form-item label="供应商">

            <el-input :value="form.supplierName" readonly placeholder="选择供应商">

              <el-button v-if="!formDisabled" slot="append" @click="supplierDlg = true">选</el-button>

            </el-input>

          </el-form-item>

        </el-col>

      </el-row>

      <el-form-item v-if="form.purchaseOrderCode" label="采购订单"><el-input :value="form.purchaseOrderCode" disabled /></el-form-item>

      <el-form-item label="备注"><el-input v-model="form.remark" :disabled="formDisabled" /></el-form-item>

      <div class="line-title">发料 <el-button v-if="!formDisabled" type="text" @click="addSendLine">添加发出物料</el-button></div>

      <el-table :data="form.sendLines" border size="small" :header-cell-style="headStyle">

        <el-table-column label="物料编码" min-width="120"><template slot-scope="s"><el-input v-model="s.row.materialCode" size="small" :disabled="formDisabled" @blur="fillMaterial(s.row)" /></template></el-table-column>

        <el-table-column prop="materialName" label="物料名称" min-width="120" />

        <el-table-column label="数量" width="130"><template slot-scope="s"><el-input-number v-model="s.row.quantity" :disabled="formDisabled" :min="0" :precision="2" size="small" style="width:100%" /></template></el-table-column>

        <el-table-column label="仓库" min-width="160"><template slot-scope="s"><el-select v-model="s.row.wareHouseId" filterable :disabled="formDisabled" size="small" style="width:100%"><el-option v-for="item in warehouses" :key="item.wareHouseId" :label="item.wareHouseName" :value="item.wareHouseId" /></el-select></template></el-table-column>

        <el-table-column prop="allocationText" label="系统分配" min-width="160" show-overflow-tooltip />

        <el-table-column v-if="!formDisabled" label="操作" width="70"><template slot-scope="s"><el-button type="text" @click="form.sendLines.splice(s.$index, 1)">删</el-button></template></el-table-column>

      </el-table>

      <div class="line-title">收回 <el-button v-if="!formDisabled" type="text" @click="addReceiveLine">添加收回物料</el-button></div>

      <el-table :data="form.receiveLines" border size="small" :header-cell-style="headStyle">

        <el-table-column label="物料编码" min-width="120"><template slot-scope="s"><el-input v-model="s.row.materialCode" size="small" :disabled="formDisabled" @blur="fillMaterial(s.row)" /></template></el-table-column>

        <el-table-column prop="materialName" label="物料名称" min-width="120" />

        <el-table-column label="数量" width="130"><template slot-scope="s"><el-input-number v-model="s.row.quantity" :disabled="formDisabled" :min="0" :precision="2" size="small" style="width:100%" /></template></el-table-column>

        <el-table-column label="仓库" min-width="160"><template slot-scope="s"><el-select v-model="s.row.wareHouseId" filterable :disabled="formDisabled" size="small" style="width:100%"><el-option v-for="item in warehouses" :key="item.wareHouseId" :label="item.wareHouseName" :value="item.wareHouseId" /></el-select></template></el-table-column>

        <el-table-column v-if="!formDisabled" label="操作" width="70"><template slot-scope="s"><el-button type="text" @click="form.receiveLines.splice(s.$index, 1)">删</el-button></template></el-table-column>

      </el-table>

    </el-form>

    <span slot="footer">

      <el-button @click="visible = false">取消</el-button>

      <el-button v-if="!formDisabled" type="primary" @click="save">保存</el-button>

    </span>

    <material-selector :visible.sync="matDlg" :multiple="false" @select="onMaterial" />

    <supplier-selector :visible.sync="supplierDlg" @select="onSupplierPick" />

    <el-dialog title="选择生产工单" :visible.sync="orderDlg" width="700px" append-to-body>

      <el-table :data="orders" border :header-cell-style="headStyle" @row-click="selectOrder">

        <el-table-column prop="productionOrderCode" label="工单号" min-width="140" />

        <el-table-column prop="materialCode" label="成品编码" min-width="120" />
        <el-table-column prop="orderStatus" label="状态" width="90">
          <template slot-scope="s">{{ s.row.orderStatus === '1' ? '已下达' : s.row.orderStatus === '3' ? '已完工' : (s.row.orderStatus || '') }}</template>
        </el-table-column>

      </el-table>

    </el-dialog>

  </el-dialog>

</template>



<script>

import request from '../../api/request'

import { fetchPerms } from '../../api/auth'

import MaterialSelector from '../../components/MaterialSelector.vue'

import SupplierSelector from '../../components/SupplierSelector.vue'



function today() {

  const d = new Date()

  const p = n => String(n).padStart(2, '0')

  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' 00:00:00'

}



export default {

  name: 'ProductionSubcontractAddOrUpdate',

  components: { MaterialSelector, SupplierSelector },

  data() {

    return {

      visible: false,

      readonly: false,

      orderDlg: false,

      matDlg: false,

      supplierDlg: false,
      codeReadonly: false,
      routingRequestId: 0,

      pickLineType: 'send',

      orders: [],
      ordersRequestId: 0,

      warehouses: [],

      routings: [],

      permCodes: [],

      form: { sendLines: [], receiveLines: [], productionOrderCode: '', supplierName: '' },

      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' },

      rules: {

        bizDate: [{ required: true, message: '日期不能为空', trigger: 'change' }],

        productionOrderId: [{ required: true, message: '请选择生产工单', trigger: 'change' }],

        orderRoutingId: [{ required: true, message: '请选择委外工序', trigger: 'change' }]

      }

    }

  },

  computed: {

    formDisabled() { return this.readonly || String(this.form.approveStatus || '0') !== '0' },

    showViewToolbar() { return this.readonly && !!this.form.id },

    dialogTitle() {

      if (this.readonly) return '委外详情'

      return this.form.id ? '修改委外' : '新增委外'

    }

  },

  created() {

    this.loadPerms()

    this.loadOrders()

    this.loadWarehouses()

  },

  methods: {

    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'productionSubcontract' }).then(res => {
        if (!this.visible || this.form.id) return
        const rule = res.data || {}
        this.codeReadonly = !!rule.codeReadonly
        if (rule.previewCode) this.form.code = rule.previewCode
      }).catch(() => {})
    },

    isAuth(perm) {

      const user = this.$store.state.user || {}

      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []

      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true

      return this.permCodes.indexOf(perm) >= 0

    },

    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },

    loadOrders(includeId) {
      const include = includeId || (this.form && this.form.productionOrderId) || ''
      const requestId = ++this.ordersRequestId
      return request.get('/production/order/ordersForBiz', { params: { includeProductionOrderId: include } })
        .then(res => { if (requestId === this.ordersRequestId) this.orders = res.data || [] })
        .catch(() => { if (requestId === this.ordersRequestId) this.orders = [] })
    },

    loadWarehouses() {

      request.get('/production/subcontract/warehouses').then(res => { this.warehouses = res.data || [] }).catch(() => {})

    },

    loadRoutings(reset) {

      const id = this.form.productionOrderId

      const requestId = ++this.routingRequestId

      if (!id) { this.routings = []; return }

      if (reset) this.form.orderRoutingId = ''

      request.get('/production/subcontract/outRoutings', { params: { productionOrderId: id } }).then(res => {
        if (requestId === this.routingRequestId && this.form.productionOrderId === id) this.routings = res.data || []
      }).catch(() => { if (requestId === this.routingRequestId) this.routings = [] })

    },

    pickOrder() {
      this.orderDlg = true
      this.loadOrders(this.form.productionOrderId)
    },

    selectOrder(row) {
      if (!row) return
      this.form.productionOrderId = row.productionOrderId
      this.form.productionOrderCode = row.productionOrderCode || ''
      this.orderDlg = false
      this.loadRoutings(true)
    },

    onSupplierPick(row) {
      this.form.supplierId = row.supplierId
      this.form.supplierName = row.supplierName || ''
    },

    addSendLine() {
      this.pickLineType = 'send'
      this.matDlg = true
    },

    addReceiveLine() {
      this.pickLineType = 'receive'
      this.matDlg = true
    },

    onMaterial(row) {
      if (!row) return
      const line = { materialId: row.materialId, materialCode: row.materialCode || '', materialName: row.materialName || '', quantity: 1, wareHouseId: '' }
      if (this.pickLineType === 'receive') this.form.receiveLines.push(line)
      else this.form.sendLines.push(line)
    },

    blankLine() { return { materialId: '', materialCode: '', materialName: '', quantity: 1, wareHouseId: '' } },

    fillMaterial(row) {

      const code = (row.materialCode || '').trim()

      if (!code) return

      request.get('/base/material/byCode', { params: { materialCode: code } }).then(res => {

        const m = res.data || {}

        row.materialId = m.materialId || ''

        row.materialName = m.materialName || ''

        row.materialCode = m.materialCode || code

      }).catch(() => {})

    },

    onClosed() {

      this.readonly = false

      this.orderDlg = false

      this.matDlg = false

      this.supplierDlg = false

      this.routings = []

      this.routingRequestId++

      this.form = { sendLines: [], receiveLines: [], productionOrderCode: '', supplierName: '' }

    },

    init(idOrRow, readonly) {

      this.visible = true

      this.readonly = !!readonly

      if (this.readonly && idOrRow) {

        const openView = prefill => {

          const bizDate = prefill.bizDate && String(prefill.bizDate).length <= 10 ? prefill.bizDate + ' 00:00:00' : (prefill.bizDate || '')

          this.form = { id: prefill.id, code: prefill.code || '', bizDate, productionOrderId: prefill.productionOrderId || '', productionOrderCode: prefill.productionOrderCode || '', orderRoutingId: prefill.orderRoutingId || '', supplierId: prefill.supplierId || '', supplierName: prefill.supplierName || '', purchaseOrderId: prefill.purchaseOrderId || '', purchaseOrderCode: prefill.purchaseOrderCode || '', approveStatus: String(prefill.approveStatus || '0'), remark: prefill.remark || '', sendLines: [], receiveLines: [] }
          this.loadOrders(this.form.productionOrderId).then(() => {
            if (!this.form.productionOrderCode && this.form.productionOrderId) {
              const hit = (this.orders || []).find(o => o.productionOrderId === this.form.productionOrderId)
              if (hit) this.form.productionOrderCode = hit.productionOrderCode || ''
            }
          })

          this.loadRoutings(false)

          request.get('/production/subcontract/lines', { params: { id: prefill.id } }).then(res => {

            const lines = res.data || []

            this.form.sendLines = lines.filter(line => line.lineType === 'send')

            this.form.receiveLines = lines.filter(line => line.lineType === 'receive')

          }).catch(() => {})

        }

        const id = typeof idOrRow === 'object' ? idOrRow.id : idOrRow

        if (id) {

          request.get('/production/subcontract/info', { params: { id } }).then(res => {
            openView(res.data || (typeof idOrRow === 'object' ? idOrRow : { id }))
          }).catch(() => { openView(typeof idOrRow === 'object' ? idOrRow : { id }) })

        }

        return

      }

      const prefill = idOrRow && typeof idOrRow === 'object' ? idOrRow : null

      this.codeReadonly = false

      this.form = { code: '', bizDate: today(), productionOrderId: (prefill && prefill.productionOrderId) || '', productionOrderCode: (prefill && prefill.productionOrderCode) || '', orderRoutingId: '', supplierId: '', supplierName: '', approveStatus: '0', remark: '', sendLines: [], receiveLines: [] }

      this.resolveCode()
      if (this.form.productionOrderId) {
        const orderId = this.form.productionOrderId
        this.loadOrders(orderId).then(() => {
          if (!this.visible || this.form.productionOrderId !== orderId || this.form.productionOrderCode) return
          const hit = this.orders.find(order => order.productionOrderId === orderId)
          if (hit) this.form.productionOrderCode = hit.productionOrderCode || ''
        })
      }

      if (this.form.productionOrderId) this.loadRoutings(false)

    },

    save() {

      this.$refs.dataForm.validate(valid => {

        if (!valid) return

        request.post('/production/subcontract/save', {

          id: this.form.id, code: this.form.code, bizDate: this.form.bizDate, productionOrderId: this.form.productionOrderId, orderRoutingId: this.form.orderRoutingId,

          supplierId: this.form.supplierId, supplierName: this.form.supplierName, remark: this.form.remark,

          sendLines: this.form.sendLines, receiveLines: this.form.receiveLines

        }).then(() => { this.$message.success('保存成功'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})

      })

    },

    approve(action, message, status) {

      this.$confirm(message, '提示', { type: 'warning' }).then(() => {

        request.post('/production/subcontract/' + action, { id: this.form.id }).then(() => {

          this.$message.success('操作成功')

          this.form.approveStatus = status

          this.readonly = true

          this.$emit('refreshDataList')

        }).catch(() => {})

      }).catch(() => {})

    },

    remove() {

      this.$confirm('删除后将释放已占用的可用量，是否继续？', '提示', { type: 'warning' }).then(() => {

        request.post('/production/subcontract/delete', { id: this.form.id }).then(() => { this.$message.success('已删除'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})

      }).catch(() => {})

    }

  }

}

</script>



<style scoped>

.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }

.doc-dialog-title { font-size: 16px; font-weight: 600; }

.doc-dialog-actions .el-button { margin-left: 0; }

.line-title { margin: 12px 0 8px; font-weight: 600; }

</style>


